/*
* Palo Alto Theme — custom.js
*
* Automatic cart discount
* -----------------------
* Keeps the cart carrying the right discount code for its item count, without the
* customer typing anything:
*
*   - fewer than 3 items  -> no automatic code
*   - 3 or more items     -> MYSTERY
*
* Halloween20 and Halloween30 are not applied, removed, or sent to checkout.
* MYSTERY is a normal (manual) discount code in Shopify Admin. It is applied only
* when every counted item was added from the Halloween collection template
* (collection.helloween). Those lines carry the property _auto_discount=collection.
* Adding a product from the eye collection, another collection, a product page,
* the homepage, search, or anywhere else removes the code. The Mystery Pair gift
* and shipping insurance are not counted toward the 3.
*
* Codes are applied with the Cart AJAX API (POST /cart/update.js { discount }) and a
* hidden discount field on the cart form, so Shopify's prices show in the cart and
* carry into checkout. Shopify can store the code before the line prices change, so
* the first qualifying add waits until the prices have actually been reduced.
* Checkout is opened through /discount/MYSTERY so the same code is attached there.
* The code must exist in Shopify Admin > Discounts with no minimum quantity.
*
* Configuration comes from Theme settings > Automatic discount (see layout/theme.liquid,
* window.theme.autoDiscount). The Halloween collection does not preview Halloween20
* or Halloween30 prices.
*/

(function () {
  function cartDrawerEl() {
    return document.querySelector('[data-cart-drawer]');
  }

  function prepareCartDrawer() {
    var el = cartDrawerEl();
    if (!el) return;
    el.classList.remove('cv-h');
    el.style.contentVisibility = 'visible';
  }

  function revealCartDrawer() {
    var el = cartDrawerEl();
    if (!el) return;
    el.classList.remove('cv-h');
    el.classList.add('is-open');
    el.style.contentVisibility = 'visible';
    document.body.classList.add('js-drawer-open-cart');
    el.querySelectorAll('[data-aos]').forEach(function (node) {
      node.classList.add('aos-animate');
      node.style.opacity = '1';
      node.style.visibility = 'visible';
    });
  }

  function releaseAddButtons() {
    document.querySelectorAll('[data-add-to-cart].is-loading').forEach(function (button) {
      button.classList.remove('is-loading');
      button.classList.remove('is-disabled');
      button.removeAttribute('disabled');
      button.disabled = false;
    });
  }

  function forceOpenCartDrawer() {
    patchCartDrawer();
    var drawer = window.cart;
    if (drawer && typeof drawer.openCartDrawer === 'function' && !drawer.isCartDrawerOpen) {
      try {
        drawer.openCartDrawer();
      } catch (error) {}
    }
    revealCartDrawer();
    if (drawer) drawer.isCartDrawerOpen = true;
    releaseAddButtons();
  }

  function patchCartDrawer() {
    var drawer = window.cart;
    if (!drawer || drawer.__scrollPatched) return;
    if (typeof drawer.scrollToCartTop !== 'function' || typeof drawer.openCartDrawer !== 'function') return;

    var originalScroll = drawer.scrollToCartTop.bind(drawer);
    drawer.scrollToCartTop = function () {
      try {
        originalScroll();
      } catch (error) {
        if (drawer.cartDrawerBody) drawer.cartDrawerBody.scrollTop = 0;
      }
    };

    var originalOpen = drawer.openCartDrawer.bind(drawer);
    var opening = false;
    drawer.openCartDrawer = function () {
      if (opening) return;
      opening = true;
      try {
        originalOpen();
      } catch (error) {}
      opening = false;
      revealCartDrawer();
      drawer.isCartDrawerOpen = true;
    };

    drawer.__scrollPatched = true;
    prepareCartDrawer();
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  if (typeof window.fetch === 'function' && !window.__cartDrawerFetchPatched) {
    window.__cartDrawerFetchPatched = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var response = nativeFetch(input, init);
      if (/\/cart\/add(\.js)?(\?|$)/.test(requestUrl(input))) {
        response.then(function (res) {
          res.clone().json().then(function (data) {
            if (data && data.status) {
              releaseAddButtons();
              return;
            }
            forceOpenCartDrawer();
            setTimeout(forceOpenCartDrawer, 350);
          }).catch(function () {
            forceOpenCartDrawer();
          });
        }).catch(releaseAddButtons);
      }
      return response;
    };
  }

  document.addEventListener('theme:cart:loaded', function () {
    patchCartDrawer();
  });
  document.addEventListener('theme:cart:open', revealCartDrawer);
  document.addEventListener('theme:cart:added', forceOpenCartDrawer);
  prepareCartDrawer();

  var drawerTries = 0;
  var drawerTimer = setInterval(function () {
    drawerTries += 1;
    patchCartDrawer();
    if ((window.cart && window.cart.__scrollPatched) || drawerTries > 40) clearInterval(drawerTimer);
  }, 100);

  /* MYSTERY applies at 3 or more Halloween collection items. Halloween20 and Halloween30 do not. */
  const config = window.theme && window.theme.autoDiscount;
  if (!config || !config.enabled) return;

  const LOG_PREFIX = '[auto-discount]';
  const RELOAD_GUARD_KEY = 'autoDiscountReloadAt';
  const RELOAD_GUARD_MS = 15000;
  const SOURCE_PROPERTY = '_auto_discount';
  const SOURCE_VALUE = 'collection';
  const MYSTERY_VARIANT_ID = '55189724823894';

  const normalize = (code) => String(code || '').trim().toUpperCase();
  const retiredCodes = ['HALLOWEEN20', 'HALLOWEEN30'];

  function tierDiscountCode() {
    const configured = String(config.tierCode || '').trim();
    const upper = normalize(configured);
    if (!upper || retiredCodes.indexOf(upper) !== -1) return 'MYSTERY';
    return configured;
  }

  /* Only MYSTERY is managed. Halloween20 and Halloween30 are left untouched. */
  const ownCodes = Array.from(new Set(
    [normalize(tierDiscountCode()), 'MYSTERY'].filter((code) => code && retiredCodes.indexOf(code) === -1)
  ));

  if (!ownCodes.length) {
    console.warn(LOG_PREFIX, 'No discount codes configured in Theme settings > Automatic discount.');
    return;
  }

  const selectors = {
    cartPage: '[data-cart-page]',
    cartDrawer: '[data-cart-drawer]',
    cartDrawerTemplate: '[data-cart-drawer-template]',
    apiContent: '[data-api-content]',
    apiLineItems: '[data-api-line-items]',
    apiCartPrice: '[data-api-cart-price]',
    itemsHolder: '[data-items-holder]',
    priceHolder: '[data-cart-price-holder]',
    cartTotalPrice: '[data-cart-total-price]',
    cartTotalFormatted: '[data-cart-total-formatted]',
  };

  /* ---------- Only adds on the Halloween collection template are tagged ---------- */

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  /**
   * Tag cart/add requests that happen on the Halloween collection template.
   * Shopify keeps this property on the line, so a later add from another page
   * stays a separate, full-price line.
   */
  function stampAddBody(body) {
    if (!body) return body;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (String(body.get('id') || '') === MYSTERY_VARIANT_ID) return body;
      if (!body.get('properties[' + SOURCE_PROPERTY + ']')) {
        body.append('properties[' + SOURCE_PROPERTY + ']', SOURCE_VALUE);
      }
      return body;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (String(body.get('id') || '') === MYSTERY_VARIANT_ID) return body;
      if (!body.get('properties[' + SOURCE_PROPERTY + ']')) {
        body.append('properties[' + SOURCE_PROPERTY + ']', SOURCE_VALUE);
      }
      return body;
    }

    if (typeof body === 'string') {
      try {
        const data = JSON.parse(body);
        const stampItem = (item) => {
          if (!item || typeof item !== 'object') return;
          if (String(item.id || '') === MYSTERY_VARIANT_ID) return;
          item.properties = item.properties || {};
          if (!item.properties[SOURCE_PROPERTY]) item.properties[SOURCE_PROPERTY] = SOURCE_VALUE;
        };
        if (Array.isArray(data.items)) data.items.forEach(stampItem);
        else stampItem(data);
        return JSON.stringify(data);
      } catch (error) {
        if (body.indexOf('properties[' + SOURCE_PROPERTY + ']') !== -1) return body;
        try {
          if (String(new URLSearchParams(body).get('id') || '') === MYSTERY_VARIANT_ID) return body;
        } catch (parseError) {}
        const joiner = body.length ? '&' : '';
        return body + joiner + encodeURIComponent('properties[' + SOURCE_PROPERTY + ']') + '=' + encodeURIComponent(SOURCE_VALUE);
      }
    }

    return body;
  }

  function addedFromCollection(item) {
    const properties = item && item.properties;
    if (!properties) return false;
    return String(properties[SOURCE_PROPERTY] || '') === SOURCE_VALUE;
  }

  /**
   * Mark every add-to-cart form on the Halloween collection template.
   * The eye collection, other collections, and product pages are left unmarked.
   */
  function stampCollectionForms() {
    if (!config.isCollectionPage) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      const fieldName = 'properties[' + SOURCE_PROPERTY + ']';
      if (form.querySelector('[name="' + fieldName + '"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = fieldName;
      input.value = SOURCE_VALUE;
      form.appendChild(input);
    });
  }

  /**
   * Shipping insurance is added from the cart, not from the collection grid.
   * It must not be tagged, or it either inflates the tier or clears the code.
   */
  function bodyIsAddon(body) {
    const ids = [];
    const checkbox = document.querySelector('.addon_checkbox');
    if (checkbox && checkbox.value) ids.push(String(checkbox.value));
    const configured = String(config.addonVariantId || '');
    if (configured && configured !== '0') ids.push(configured);
    if (!ids.length || body == null) return false;

    const matches = (value) => ids.indexOf(String(value || '')) !== -1;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return matches(body.get('id'));
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return matches(body.get('id'));
    }
    if (typeof body !== 'string') return false;

    try {
      const data = JSON.parse(body);
      if (matches(data.id)) return true;
      return Array.isArray(data.items) && data.items.length > 0 && data.items.every((item) => matches(item && item.id));
    } catch (error) {
      try {
        return matches(new URLSearchParams(body).get('id'));
      } catch (parseError) {
        return false;
      }
    }
  }

  function requestHeaders(init) {
    const headers = init && init.headers;
    if (!headers) return {};
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return { auto: headers.get('X-Auto-Discount') };
    }
    return { auto: headers['X-Auto-Discount'] || headers['x-auto-discount'] };
  }

  if (typeof window.fetch === 'function') {
    const originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      let url = requestUrl(input);
      const isAdd = url.indexOf('/cart/add') !== -1;
      const internal = requestHeaders(init).auto;

      if (!internal && isAdd && config.isCollectionPage && init && init.body && !bodyIsAddon(init.body)) {
        const stamped = stampAddBody(init.body);
        if (stamped !== init.body) init = Object.assign({}, init, {body: stamped});
      }

      /* The drawer asks for this section right after an add. Bust the cache so it cannot reuse the full-price HTML from before the code was applied. */
      if (!internal && !isAdd && url.indexOf('section_id=api-cart-items') !== -1 && typeof input === 'string') {
        input = url + (url.indexOf('?') === -1 ? '?' : '&') + '_ds=' + Date.now();
      }

      /* Return the add request immediately so the drawer can open. The discount is applied before the drawer HTML is rendered. */
      return originalFetch(input, init);
    };
  }

  /**
   * Halloween collection template adds only.
   * Fewer than 3 counted items -> no automatic code.
   * 3 or more -> MYSTERY.
   * Halloween20 and Halloween30 are never applied or cleared.
   * Any add from a product page or elsewhere clears MYSTERY.
   *
   * Shipping Insurance is added at checkout. It must not change the tier.
   */
  function isCheckoutAddon(item) {
    if (!item) return false;

    const handle = String(item.handle || '').toLowerCase();
    const addonHandle = String(config.addonHandle || 'shipping-insurance').toLowerCase();
    if (handle && handle === addonHandle) return true;

    const title = String(item.product_title || item.title || '').toLowerCase();
    if (title.indexOf('shipping insurance') !== -1) return true;

    const input = document.querySelector('.addon_checkbox');
    const addonId = (input && input.value) || config.addonVariantId;
    if (!addonId) return false;
    return String(item.variant_id || item.id) === String(addonId);
  }

  /**
   * Mystery Pair is added by snippets/mystery-pair.liquid once the cart hits $100.
   * It is not a Halloween collection product, so it must not clear MYSTERY
   * and it must not count toward the 3-item tier.
   */
  function isMysteryPair(item) {
    if (!item) return false;
    if (String(item.variant_id || item.id) === MYSTERY_VARIANT_ID) return true;
    const title = String(item.product_title || item.title || '').toLowerCase();
    return title.indexOf('mystery pair') !== -1;
  }

  function discountItems(cart) {
    return ((cart && cart.items) || []).filter((item) => !isCheckoutAddon(item) && !isMysteryPair(item));
  }

  function desiredCode(cart) {
    if (!cart || !cart.item_count) return '';
    const items = discountItems(cart);
    if (!items.length || !items.every(addedFromCollection)) return '';

    const qty = items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    if (!qty) return '';

    const tierAt = Number(config.tierQty) > 0 ? Number(config.tierQty) : 3;
    if (qty >= tierAt) return normalize(tierDiscountCode());
    return '';
  }

  function routesRoot() {
    let root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root;
  }

  /**
   * Discount codes are only applied by the Ajax cart endpoint.
   * routes.cart_update_url is /cart/update, which ignores { discount }.
   */
  function withJs(url) {
    const raw = String(url || '');
    if (!raw) return routesRoot() + 'cart/update.js';
    const hashAt = raw.indexOf('#');
    const hash = hashAt === -1 ? '' : raw.slice(hashAt);
    const beforeHash = hashAt === -1 ? raw : raw.slice(0, hashAt);
    const queryAt = beforeHash.indexOf('?');
    const path = queryAt === -1 ? beforeHash : beforeHash.slice(0, queryAt);
    const query = queryAt === -1 ? '' : beforeHash.slice(queryAt);
    if (/\.js$/.test(path)) return raw;
    return path + '.js' + query + hash;
  }

  function cartFetch(url, options) {
    const init = Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options || {});
    const headers = Object.assign({}, init.headers, { 'X-Auto-Discount': '1' });
    init.headers = headers;
    return fetch(url, init);
  }

  /**
   * Hidden cart-form field. Shopify applies name="discount" when checkout is posted.
   */
  function stampDiscountInputs(code) {
    document.querySelectorAll('form[action*="/cart"]').forEach((form) => {
      const action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== -1) return;
      let input = form.querySelector('input[data-collection-discount]');
      if (!code) {
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'discount';
        input.setAttribute('data-collection-discount', 'true');
        form.appendChild(input);
      }
      input.value = code;
    });
  }

  function fetchCart() {
    return cartFetch(withJs(config.cartJsUrl || (routesRoot() + 'cart.js')), {
      headers: {Accept: 'application/json'},
    }).then((response) => response.json());
  }

  function cartLooksValid(data) {
    return Boolean(data && (Array.isArray(data.items) || Array.isArray(data.discount_codes)));
  }

  /**
   * POST /cart/update.js { discount } stores MYSTERY on the cart.
   * /cart/update without .js drops the JSON body, so the code never applies.
   */
  function updateCartDiscounts(codes) {
    const url = withJs(config.cartUpdateUrl || (routesRoot() + 'cart/update'));
    const payload = codes.join(',');

    const read = (response) => response.json().catch(() => null);

    return cartFetch(url, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({discount: payload}),
    }).then(read).then((data) => {
      if (cartLooksValid(data)) return data;
      return cartFetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json'},
        body: 'discount=' + encodeURIComponent(payload),
      }).then(read).then((formData) => formData || data);
    });
  }

  function cartChangeUrl() {
    const routes = window.theme && window.theme.routes;
    return withJs((routes && routes.cart_change_url) || '/cart/change');
  }

  function discountEntry(cart, code) {
    return (cart && cart.discount_codes || []).find((item) => normalize(item.code) === code) || null;
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  /**
   * True only when this code has actually reduced the cart total.
   * Shopify can list the code as applicable while total_discount is still 0.
   * That is not ready: the drawer and checkout would still show the full price.
   */
  function pricesIncludeDiscount(cart, code) {
    if (!code) return true;
    if (!cart || !cart.item_count) return false;
    const entry = discountEntry(cart, code);
    if (!entry || entry.applicable === false) return false;
    if ((cart.total_discount || 0) > 0) return true;
    if ((cart.original_total_price || 0) > (cart.total_price || 0)) return true;
    return (cart.items || []).some((item) => (item.original_line_price || 0) > (item.final_line_price || 0));
  }

  /**
   * /discount/CODE is the path Shopify uses for checkout. Follow it to cart.js
   * so the same code is priced on the cart, not only stored for later.
   */
  async function applyDiscountPermalink(code) {
    const root = routesRoot();
    const url = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js');
    try {
      const response = await cartFetch(url, {
        method: 'GET',
        headers: {Accept: 'application/json'},
      });
      const text = await response.text();
      try {
        const data = JSON.parse(text);
        if (data && Array.isArray(data.items)) return data;
      } catch (error) {
        /* The redirect came back as HTML. Read the cart directly. */
      }
    } catch (error) {
      console.warn(LOG_PREFIX, error);
    }
    return fetchCart();
  }

  /**
   * A same-quantity update does not make Shopify reprice a new code.
   * Move the line up by 1 and straight back. That is a real cart change,
   * which is what makes the first product pick up 20%, and the quantity
   * the shopper added is restored before the drawer opens.
   */
  async function recalculateWithRealChange(cart) {
    const item = cart && Array.isArray(cart.items)
      ? cart.items.find((line) => line && line.key && line.quantity > 0 && !isCheckoutAddon(line) && !isMysteryPair(line))
      : null;
    if (!item) return cart;

    const change = (quantity) => cartFetch(cartChangeUrl(), {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({id: item.key, quantity: quantity}),
    });

    try {
      const up = await change(item.quantity + 1);
      if (!up.ok) return cart;
      const down = await change(item.quantity);
      if (!down.ok) return up.json();
      const next = await down.json();
      return next && Array.isArray(next.items) ? next : cart;
    } catch (error) {
      console.warn(LOG_PREFIX, error);
      return cart;
    }
  }

  async function forcePricedDiscount(code, codes) {
    let updated = await applyDiscountPermalink(code);
    if (pricesIncludeDiscount(updated, code)) return updated;

    updated = await updateCartDiscounts(codes);
    if (pricesIncludeDiscount(updated, code)) return updated;

    updated = await recalculateWithRealChange(updated);
    if (pricesIncludeDiscount(updated, code)) return updated;

    await sleep(400);
    updated = await updateCartDiscounts(codes);
    if (pricesIncludeDiscount(updated, code)) return updated;

    return fetchCart();
  }

  /**
   * Checkout does not read the cart discount by itself. Shopify reads the
   * discount_code cookie, so that cookie is the source of truth for MYSTERY.
   * Halloween20 and Halloween30 are never written into this cookie.
   */
  function readDiscountCookie() {
    const parts = document.cookie ? document.cookie.split('; ') : [];
    for (let i = 0; i < parts.length; i++) {
      const splitAt = parts[i].indexOf('=');
      if (splitAt === -1) continue;
      if (parts[i].slice(0, splitAt) !== 'discount_code') continue;
      return decodeURIComponent(parts[i].slice(splitAt + 1));
    }
    return '';
  }

  function setDiscountCookie(code) {
    if (retiredCodes.indexOf(normalize(code)) !== -1) return;
    if (!code) {
      const current = normalize(readDiscountCookie());
      if (current && ownCodes.includes(current)) {
        document.cookie = 'discount_code=; path=/; max-age=0; SameSite=Lax';
      }
      return;
    }
    document.cookie = 'discount_code=' + encodeURIComponent(code) + '; path=/; max-age=259200; SameSite=Lax';
  }

  let syncing = null;

  /**
   * Make sure the cart has exactly the discount code it should have.
   * Any codes that are not ours (e.g. a customer's own code) are kept.
   *
   * @return {Promise<boolean>} true when the cart's codes were changed
   */
  function syncDiscount() {
    if (syncing) return syncing;

    syncing = (async () => {
      try {
        const cart = await fetchCart();
        const appliedEntries = cart.discount_codes || [];
        const applied = appliedEntries.map((entry) => normalize(entry.code));
        const foreign = applied.filter((code) => !ownCodes.includes(code));
        const foreignRaw = appliedEntries
          .filter((entry) => !ownCodes.includes(normalize(entry.code)))
          .map((entry) => entry.code);
        const wanted = desiredCode(cart);
        const next = wanted ? foreign.concat(wanted) : foreign;
        const exactCode = checkoutCode(cart);
        const payload = foreignRaw.concat(exactCode ? [exactCode] : []);

        stampDiscountInputs(exactCode);
        setDiscountCookie(exactCode);

        const unchanged = next.length === applied.length && next.every((code) => applied.includes(code));
        const alreadyPriced = !wanted || pricesIncludeDiscount(cart, wanted);
        if (unchanged && alreadyPriced) return false;

        let updated = unchanged ? cart : await updateCartDiscounts(payload);
        const pricedCode = checkoutCode(updated && Array.isArray(updated.items) ? updated : cart);
        stampDiscountInputs(pricedCode);

        if (wanted && !pricesIncludeDiscount(updated, wanted)) {
          updated = await forcePricedDiscount(wanted, payload);
          stampDiscountInputs(checkoutCode(updated && Array.isArray(updated.items) ? updated : cart));
        }

        const pricedNow = !wanted || pricesIncludeDiscount(updated, wanted);
        if (wanted && !pricedNow) {
          console.warn(LOG_PREFIX, `Discount code "${wanted}" is not reducing the cart total. In Shopify Admin > Discounts, create ${wanted} as a manual code that applies to the Halloween products, with no minimum quantity.`);
        }

        /* Already stored but still full price: stop here so the drawer does not refresh forever. */
        if (unchanged && !pricedNow) return false;

        return true;
      } catch (error) {
        console.warn(LOG_PREFIX, error);
        return false;
      } finally {
        syncing = null;
      }
    })();

    return syncing;
  }

  /**
   * Wrap the theme's CartDrawer.getCart() so the discount is synced *before* the drawer
   * is re-rendered. That way the drawer shows the discounted prices on the first render
   * after an add-to-cart or a quantity change.
   *
   * @return {boolean} whether the drawer was already patched before this call
   */
  /**
   * Mobile WebKit reads an empty string from a <template> that sits inside
   * content-visibility: hidden, so the theme copies nothing into the drawer
   * and the panel stays white. Drop that class before the drawer ever opens.
   */
  function prepareCartDrawer() {
    const drawerEl = document.querySelector(selectors.cartDrawer);
    if (!drawerEl) return;
    drawerEl.classList.remove('cv-h');
    drawerEl.style.contentVisibility = 'visible';
  }

  function revealCartDrawer() {
    const drawerEl = document.querySelector(selectors.cartDrawer);
    if (!drawerEl) return;
    drawerEl.classList.remove('cv-h');
    drawerEl.style.contentVisibility = 'visible';
    drawerEl.querySelectorAll('[data-aos]').forEach((node) => {
      node.classList.add('aos-animate');
    });
    void drawerEl.offsetHeight;
  }

  function patchCartDrawer() {
    const drawer = window.cart;
    if (!drawer || typeof drawer.getCart !== 'function') return false;
    prepareCartDrawer();
    if (drawer.__autoDiscountPatched) return true;

    if (typeof drawer.scrollToCartTop === 'function' && !drawer.__scrollPatched) {
      const originalScroll = drawer.scrollToCartTop.bind(drawer);
      drawer.scrollToCartTop = function () {
        try {
          originalScroll();
        } catch (error) {
          const body = drawer.cartDrawerBody;
          if (body) body.scrollTop = 0;
        }
      };
      drawer.__scrollPatched = true;
    }

    if (!drawer.__discountGetCart) {
      const originalGetCart = drawer.getCart.bind(drawer);
      drawer.getCart = function () {
        if (drawer.__skipDiscountSync) {
          drawer.__skipDiscountSync = false;
          return originalGetCart();
        }
        return syncDiscount().finally(function () {
          drawer.__skipDiscountSync = true;
          originalGetCart();
        });
      };
      drawer.__discountGetCart = true;
    }

    drawer.__autoDiscountPatched = true;

    return false;
  }

  /**
   * Refresh the (not yet opened) cart drawer template with fresh cart HTML so the first
   * time it opens it already shows the discount. Used on page load only.
   */
  async function refreshDrawerTemplate() {
    const template = document.querySelector(selectors.cartDrawerTemplate);
    if (!template) return;

    try {
      const response = await fetch(config.cartSectionUrl, {cache: 'no-store'});
      const html = await response.text();
      const parsed = document.createElement('div');
      parsed.innerHTML = html;

      const api = parsed.querySelector(selectors.apiContent);
      if (!api) return;

      const lineItems = api.querySelector(selectors.apiLineItems);
      const price = api.querySelector(selectors.apiCartPrice);
      const root = template.content;

      const itemsHolder = root.querySelector(selectors.itemsHolder);
      const priceHolder = root.querySelector(selectors.priceHolder);
      const totalPrice = root.querySelector(selectors.cartTotalPrice);

      if (itemsHolder && lineItems) itemsHolder.innerHTML = lineItems.innerHTML;
      if (priceHolder && price) priceHolder.innerHTML = price.innerHTML;

      const totalFormatted = price && price.querySelector(selectors.cartTotalFormatted);
      if (totalPrice && totalFormatted) {
        totalPrice.textContent = totalFormatted.getAttribute('data-cart-total-formatted');
      }
    } catch (error) {
      console.warn(LOG_PREFIX, error);
    }
  }

  /**
   * The cart page has its own CartDrawer instance we can't reach, so a full reload is the
   * only way to re-render it with the new discount. Guarded so it can never loop.
   */
  function reloadCartPageOnce() {
    const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
    if (Date.now() - last < RELOAD_GUARD_MS) return;

    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
    window.location.reload();
  }

  function isCartPage() {
    return Boolean(document.querySelector(selectors.cartPage));
  }

  function onPageLoad() {
    stampCollectionForms();
    patchCartDrawer();

    syncDiscount().then((changed) => {
      if (!changed) return;

      if (isCartPage()) {
        reloadCartPageOnce();
      } else if (window.cart && window.cart.isCartDrawerLoaded) {
        window.cart.getCart();
      } else {
        refreshDrawerTemplate();
      }
    });
  }

  let refreshQueued = false;

  /**
   * If this render happened before the code was priced (the first add used to do
   * this), sync and draw the drawer once more. The guard stops that second draw
   * from queuing another one.
   */
  function onCartRendered() {
    patchCartDrawer();
    if (refreshQueued) {
      refreshQueued = false;
      return;
    }

    syncDiscount().then((changed) => {
      if (!changed) return;

      if (window.cart && typeof window.cart.getCart === 'function') {
        refreshQueued = true;
        window.cart.getCart();
      } else if (isCartPage()) {
        reloadCartPageOnce();
      }
    });
  }

  /**
   * The code string Shopify should see in the checkout URL.
   * Matching stays case-insensitive, but the link uses the code from Theme settings.
   */
  function checkoutCode(cart) {
    const wanted = desiredCode(cart);
    if (!wanted || retiredCodes.indexOf(wanted) !== -1) return '';
    if (wanted === normalize(tierDiscountCode())) return tierDiscountCode();
    return wanted;
  }

  /**
   * Open checkout through Shopify's discount link so the manual code is attached.
   * 3 or more Halloween collection items use MYSTERY.
   */
  async function goToCheckoutWithCollectionDiscount() {
    try {
      await syncDiscount();
    } catch (error) {
      console.warn(LOG_PREFIX, error);
    }

    const cart = await fetchCart().catch(() => null);
    const code = cart ? checkoutCode(cart) : '';
    const root = routesRoot();

    if (code) {
      setDiscountCookie(code);
      /* A full page visit is what attaches a manual code for checkout. checkout?discount= is ignored once the cart session has no priced code. */
      const checkoutPath = root + 'checkout';
      window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(checkoutPath));
      return;
    }

    window.location.assign(root + 'checkout');
  }

  window.theme.syncCollectionDiscount = syncDiscount;
  window.theme.goToCheckoutWithCollectionDiscount = goToCheckoutWithCollectionDiscount;

  document.addEventListener('click', (event) => {
    const button = event.target && event.target.closest ? event.target.closest('[name="checkout"], .cart__checkout') : null;
    if (!button || button.dataset.collectionDiscountBypass === '1') return;
    if (button.getAttribute('onclick') && button.getAttribute('onclick').indexOf('checkDown') !== -1) return;

    const form = button.form;
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    goToCheckoutWithCollectionDiscount();
  }, true);

  document.addEventListener('theme:cart:loaded', () => {
    patchCartDrawer();
    revealCartDrawer();
  });
  document.addEventListener('theme:cart:open', revealCartDrawer);
  prepareCartDrawer();
  document.addEventListener('theme:cart:added', onCartRendered);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onPageLoad);
  } else {
    onPageLoad();
  }
})();
